/**
 * @ Author: Housefolios
 * @ Create Time: 2021-12-01 15:08:58
 * @ Modified by: David Helmick
 * @ Modified time: 2025-05-07 19:52:57
 * @ Description: Property details view showing the comps found for this property
 */

import React, { Fragment, useEffect, useState } from 'react'
import {
  strategyAbsTopRightPinkSx,
  strategyAvatarBlueLargeSx,
  strategyCenterTextSx,
  strategyCompCardSx,
  strategyCompImgSx,
  strategyDangerChipSx,
  strategyDarkTextSx,
  strategyDrawerLegendSx,
  strategyFixedBottomBarSx,
  strategyFlexGrowSx,
  strategyFullHeight100Sx,
  strategyIconBlueBgSx,
  strategyIconGap10Style,
  strategyIconSize40Sx,
  strategyMarginBottom25Sx,
  strategyMarginBottomNeg30Sx,
  strategyMarginRight10Sx,
  strategyMarginTop10OnlySx,
  strategyMarginTop10Sx,
  strategyMarginTop5Sx,
  strategyMutedGraySx,
  strategyOverflowScrollSx,
  strategyPad10Sx,
  strategyPad5Sx,
  strategyPadBottom0Sx,
  strategyPagePadSx,
  strategyPositionCloseSx,
  strategyTransparentCenterSx,
  strategyTransparentRelCenterSx,
  strategyWhiteSpaceNormalSx,
  strategyFlexSelfCenterSx,
  strategyWhiteTextSx,
  strategyWidth400Sx,
} from '@/housefolios-components/PropertyContainer/CenterPage/Common/strategyDashboardSx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Cropper from 'react-easy-crop'

// Additional lodash imports
import { map, isEmpty } from '@/utils/lodash'
// Centralized lodash imports - much cleaner!
import {
  minBy,
  maxBy,
  meanBy,
  filter,
  remove,
  toUpper,
  toLower,
  truncate,
  padStart,
  head,
  toString,
  replace,
  intersection,
  includes,
  isEqual,
  pull,
  ceil,
  slice,
  intersectionBy,
  concat,
  compact,
  startCase,
  reduce,
  forEach,
  uniqBy,
  uniqWith,
  orderBy,
  isNil,
  get,
  isString,
  every,
  split,
  sum,
  find,
} from '@/utils/lodash'

import Slider1 from 'react-slick'

import CompsCard from '../CompsCard'
import CountUp from '@/utils/SafeCountUp'

import loadImage from '@/utils/loadImage'

import { useDropzone } from 'react-dropzone'

import {
  Grid,
  Avatar,
  Backdrop,
  Button,
  ButtonGroup,
  Card,
  Checkbox,
  Chip,
  CircularProgress,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  FormGroup,
  IconButton,
  ImageListItemBar,
  InputAdornment,
  List,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Select,
  Slider,
  Switch,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  Box,
} from '@mui/material'
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone'
import CheckIcon from '@mui/icons-material/Check'
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone'
import CloudUploadTwoToneIcon from '@mui/icons-material/CloudUploadTwoTone'
import CompareIcon from '@mui/icons-material/Compare'
import EditIcon from '@mui/icons-material/Edit'
import HomeIcon from '@mui/icons-material/Home'
import LinearScaleIcon from '@mui/icons-material/LinearScale'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import SquareFootIcon from '@mui/icons-material/SquareFoot'
import ListIcon from '@mui/icons-material/List'
import {
  GET_COMPPROPERTIES,
  GET_PROPERTY,
} from '@/housefolios-components/PropertyContainer/queries'
import { ApolloConsumer } from '@/components/ApolloConsumer'
import { useMutation } from '@apollo/client/react'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import {
  ADD_COMPPROPERTY,
  IMAGE_UPLOAD,
} from '@/housefolios-components/TitleButtons/AddPropertyButton/mutations'
import { NumericFormat } from 'react-number-format'
import { enqueueSnackbar } from 'notistack'
import {
  DELETE_COMP,
  DELETE_IMAGE_MULTI,
  UPDATE_COMPPROPERTY,
  UPDATE_COMPPROPERTIES,
  SAVE_ANALYSIS,
  DELETE_IMAGE,
  GET_RENTAL_COMPS,
} from '@/housefolios-components/PropertyContainer/mutations'

import Map from '../../../Properties/Map'
import { PacmanLoader } from 'react-spinners'
import BlockUi from 'react-block-ui'
import {
  CompareOutlined,
  DeleteTwoTone,
  GridOnTwoTone,
  KeyboardArrowDownTwoTone,
  PollTwoTone,
  RoomTwoTone,
} from '@mui/icons-material'
import Alert from '@mui/material/Alert'
import DeleteComps from '@/housefolios-components/Comps/DeleteComps'
import MyPropertiesFilter from '@/layout-components/HeaderDrawer'
import CompsList from '../CompsList'
import Pagination from '@mui/material/Pagination'
import {
  PropertyCardSkeleton,
  PropertyListSkeleton,
} from '@/housefolios-components/Property/PropertyCardSkeleton'
import { GET_ZIP_VALUE } from '@/housefolios-components/TitleButtons/AddPropertyButton/queries'
import { GET_STOCKPILE } from '@/housefolios-components/Marketplace/queries'
import { STATES } from '@/constants/states'
import Autocomplete from '@mui/material/Autocomplete'
import { useStopwatch } from 'react-timer-hook'
import AllPropertiesFiltered from '@/housefolios-components/Properties/AllPropertiesFiltered'
import RentalCompsCard from '@/housefolios-components/PropertyContainer/CenterPage/RentalCompsCard'
import ImageCropper from '@/housefolios-components/Dialogs/ImageCropper'
import { getZipValues } from '../../../../utils/addProperty'
import { handlePlaceResult } from '@/utils/handlePlaceResult'
import { usePlaceAutocomplete } from '@/utils/placeAutocomplete'
import { statesShort } from '@/utils/states'
import { searchToolbarIconButtonProps } from '@/theme/skinSx'
import { compMarkerColor } from '@/housefolios-components/PropertyContainer/CenterPage/compMarkerColors'

const ORIENTATION_TO_ANGLE = {
  3: 180,
  6: 90,
  8: -90,
}

const hostname = import.meta.env.VITE_HOSTNAME
const apiKey = import.meta.env.VITE_HOUSEFOLIOS_APIKEY
const apiID = import.meta.env.VITE_HOUSEFOLIOS_APIID
const googleApiKey = import.meta.env.VITE_GOOGLE_APIKEY

let sortingChoices = [
  {
    title: 'Price - low to high',
    textAlign: 'left',
    name: 'estval-asc',
  },
  {
    title: 'Price - high to low',
    textAlign: 'left',
    name: 'estval-desc',
  },
  {
    title: 'SqFt - low to high',
    name: 'sqft-asc',
  },
  {
    title: 'SqFt - high to low',
    name: 'sqft-desc',
  },
  {
    title: 'Year - low to high',
    name: 'year-asc',
  },
  {
    title: 'Year - high to low',
    name: 'year-desc',
  },
]

//Sorting function copied from properties/marketplace page. Removed marketplaceOrderBy.
function desc(a, b, orderBy) {
  if (isString(get(a, orderBy)) && isString(get(b, orderBy))) {
    if (!get(b, orderBy) && !get(a, orderBy)) {
      return 0
    }
    if (!get(b, orderBy)) {
      return 1
    }
    if (!get(a, orderBy)) {
      return -1
    }
    if (
      every(get(a, orderBy), (c) => c <= '9' && c >= '0') &&
      every(get(b, orderBy), (c) => c <= '9' && c >= '0')
    ) {
      if (Number(get(b, orderBy)) < Number(get(a, orderBy))) {
        return -1
      }
      if (Number(get(b, orderBy)) > Number(get(a, orderBy))) {
        return 1
      }
      return 0
    } else {
      if (
        get(b, orderBy).toLowerCase() < get(a, orderBy).toLowerCase()
      ) {
        return -1
      }
      if (
        get(b, orderBy).toLowerCase() > get(a, orderBy).toLowerCase()
      ) {
        return 1
      }
      return 0
    }
  } else {
    if (isNil(get(b, orderBy)) && isNil(get(a, orderBy))) {
      return 0
    }
    if (isNil(get(b, orderBy))) {
      return 1
    }
    if (isNil(get(a, orderBy))) {
      return -1
    }
    if (get(b, orderBy) < get(a, orderBy)) {
      return -1
    }
    if (get(b, orderBy) > get(a, orderBy)) {
      return 1
    }
    return 0
  }
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map((el) => el[0])
}

function getSorting(order, orderBy) {
  return order === 'desc'
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy)
}

function SliderArrowNext(props) {
  const { className, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-right']} />
    </div>
  )
}

function SliderArrowPrev(props) {
  const { className, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-left']} />
    </div>
  )
}

const REHAB_LEVELS = [
  {
    value: 'Fully Rehabbed',
    label: 'Fully Rehabbed',
  },
  {
    value: 'Partially Rehabbed',
    label: 'Partially Rehabbed',
  },
  {
    value: 'No Rehab Needed',
    label: 'No Rehab Needed',
  },
  {
    value: 'Needs Partial Rehab',
    label: 'Needs Partial Rehab',
  },
  {
    value: 'Needs Major Rehab',
    label: 'Needs Major Rehab',
  },
]

function CenterPageComps(props) {
  const {
    property = {},
    comps,
    compsLoading,
    compsBackendLoading,
    organization,
  } = props

  const showCompsSkeleton =
    (compsLoading || compsBackendLoading) && isEmpty(comps)

  const hiddenUp = useMediaQuery((theme) =>
    theme.breakpoints.up('md'),
  )

  const numberFormat = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })

  const currencyFormat = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })

  const [activeTab, setActiveTab] = useState('1')

  const [compMenu, setCompMenu] = useState(null)
  const handleMenuOpen = (event) => {
    setCompMenu(event.currentTarget)
  }

  const handleMenuClose = (event) => {
    setCompMenu(null)
  }

  const [selectedEditImage, setSelectedEditImage] = useState({})
  const [replaceImage, setReplaceImage] = useState(false)

  const [editImageMoreVert, setEditImageMoreVert] = useState(null)
  const handleEditImageMoreVertOpen = (event, image) => {
    setEditImageMoreVert(event.currentTarget)
    setSelectedEditImage(image)
  }

  const handleEditImageMoreVertClose = (event) => {
    setEditImageMoreVert(null)
    setSelectedEditImage({})
  }

  const [openEditImage, setOpenEditImage] = useState(false)
  const handleOpenEditImage = (image) => {
    setOpenEditImage(true)
    setSelectedEditImage(image)
  }
  const handleCloseEditImage = () => {
    setOpenEditImage(false)
    // handleEditImageMoreVertClose()
  }

  //   const [items, setItems] = React.useState(map(images, image => (
  //     {
  //         id: image._id,
  //         src: image.url,
  //         width: 4,
  //         height: 3,
  //     }
  // )))

  const saveCroppedImage = async (croppedImage, replaceImage) => {
    setLoader(true)
    try {
      const imageId = get(selectedEditImage, `_id`)
      let newSelectedImages = selectedImages
      if (edit) {
        await imageUpload({
          variables: {
            documentId: compPropertyInput.mainProperty,
            imageUrls: [croppedImage],
            collection: 'compProperty',
          },
          refetchQueries: [
            {
              query: GET_COMPPROPERTIES,
              variables: { propertyId: property._id },
            },
            {
              query: GET_PROPERTY,
              variables: { id: property._id },
            },
          ],
        })
      } else {
        newSelectedImages = concat(newSelectedImages, [croppedImage])
        setSelectedImages(newSelectedImages)
      }
      if (replaceImage) {
        if (imageId) {
          let newImages = [...images]
          remove(newImages, (image) => image._id === imageId)
          await deleteFile({
            refetchQueries: [
              {
                query: GET_COMPPROPERTIES,
                variables: { propertyId: property._id },
              },
              {
                query: GET_PROPERTY,
                variables: { id: property._id },
              },
            ],
            variables: {
              _id: imageId,
            },
          })
          // setImages(newImages)
        } else {
          pull(newSelectedImages, selectedEditImage)
          setSelectedImages(newSelectedImages)
        }
      }
      enqueueSnackbar(`Image edited`, {
        variant: 'success',
        autoHideDuration: 3000,
      })
    } catch (e) {
      console.error(e)
    }
    handleCloseEditImage()
    handleEditImageMoreVertClose()
    setLoader(false)
  }

  //const [comps, setComps] = useState('soldComps');
  // const handleChange = event => {
  //   setComps(event.target.value);
  // };

  const [openAddCompAddress, setOpenAddCompAddress] = useState(false)
  const handleOpenAddCompAddress = () => {
    setOpenAddCompAddress(true)
    handleMenuClose()
  }
  const handleCloseAddCompAddress = () => {
    setOpenAddCompAddress(false)
    setLoader(false)
    pause()
  }

  const [loader, setLoader] = useState(false)

  const { seconds, minutes, pause, reset } = useStopwatch({
    autoStart: false,
  })

  const [openAddComp, setOpenAddComp] = useState(false)
  const handleOpenAddComp = () => {
    setOpenAddComp(true)
  }
  const handleCloseAddComp = () => {
    setOpenAddComp(false)
    setLoader(false)
    setAnchorElActionsMenu(null)
    pause()
  }

  const [placeResult, setPlaceResult] = useState(null)

  const [ordering, setOrdering] = useState('')

  const [orderByTarget = 'saleDate', order = 'desc'] = split(
    ordering || 'saleDate-desc',
    '-',
  )

  const [compPropertyInput, setCompPropertyInput] = useState({})
  const [selectedImages, setSelectedImages] = useState([])
  const [images, setImages] = useState([])
  const [edit, setEdit] = useState(false)

  const [openDeleteImage, setOpenDeleteImage] = useState(false)
  const [selectedImageDelete, setSelectedImageDelete] = useState(null)

  const [deleteFiles] = useMutation(DELETE_IMAGE_MULTI, {
    refetchQueries: [
      {
        query: GET_COMPPROPERTIES,
        variables: { propertyId: property._id },
      },
      {
        query: GET_PROPERTY,
        variables: { id: property._id },
      },
    ],
  })

  const toggleOpenDeleteImage =
    (_id = null) =>
    () => {
      setOpenDeleteImage(!openDeleteImage)
      setSelectedImageDelete(_id)
    }

  const [menu, setMenu] = useState('')
  const [anchorElDefinition, setAnchorElDefinition] = useState(null)
  const [menuName, setMenuName] = useState(null)
  const [menuFormat, setMenuFormat] = useState(null)
  const [propertyData, setPropertyData] = useState(null)
  const [showMenu, setShowMenu] = useState(true)
  const handleMenu = () => {
    setShowMenu(false)
  }

  const handleDefinition = (name, anchorEl, menuName, menuFormat) => {
    setMenu(name)
    setAnchorElDefinition(anchorEl)
    setMenuName(menuName)
    setMenuFormat(menuFormat)
  }

  const onSubmitDelete = async (event) => {
    setLoader(true)
    const toggle = toggleOpenDeleteImage()
    let newImages = [...images]
    remove(newImages, (image) => image._id === selectedImageDelete)
    deleteFiles({
      variables: {
        ids: [selectedImageDelete],
      },
    })
      .then(async ({ data  }) => {
        setSelectedImageDelete(null)
        enqueueSnackbar(`Image Deleted`, {
          variant: 'success',
          autoHideDuration: 3000,
        })
        handleEditImageMoreVertClose()
        toggle()
        setImages(newImages)
        setLoader(false)
      })
      .catch((error) => {
        enqueueSnackbar(`Image failed to delete`, {
          variant: 'error',
          autoHideDuration: 3000,
        })
        toggle()
        setLoader(false)
      })
    event.preventDefault()
  }

  const searchForComp = async (client) => {
    setLoader(true)
    reset()
    let location = handlePlaceResult(placeResult, property)
    const { loc } = location

    const streetAddress = location.streetAddress

    let data
    let error
    // { data, error } = await client.query({
    //   query: GET_ZILLOW,
    //   variables: {
    //     addressInput: {
    //       address: streetAddress.replace('#', '%23').replace('&', '%26'),
    //       city: location.locality,
    //       state: location.administrative_area_level_1,
    //       zip: location.postal_code,
    //     },
    //   },
    //   errorPolicy: 'ignore',
    // })

    data = {
      apiKey: apiKey,
      orgID: apiID,
      action: 'single_comp',
      type: 'Single Family',
      env:
        hostname === 'localhost' ||
        hostname === 'dev-admin.housefolios.com'
          ? 'dev'
          : 'live',
      address: toUpper(
        streetAddress.replace('#', '%23').replace('&', '%26'),
      ),
      latitude: loc ? loc.lat : null,
      longitude: loc ? loc.lng : null,
      city: toLower(location.locality),
      zips: padStart(
        truncate(location.postal_code, {
          length: 5,
          omission: '',
        }),
        5,
        '0',
      ),
      state: location.administrative_area_level_1,
    }

    const str_json = JSON.stringify(data)
    let response = { ok: false }
    try {
      response = await fetch(
        hostname === 'localhost'
          ? 'http://data.housefolios.com/housefoliosdev-api.php'
          : //? 'http://housefolios-data.test/housefoliosdev-api.php'
            hostname === 'dev-admin.housefolios.com'
            ? 'https://data.housefolios.com/housefoliosdev-api.php'
            : 'https://data.housefolios.com/housefolios-api.php',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: str_json,
        },
      )
    } catch (error) {
      console.log(error)
    }
    let result = response.ok ? await response.json() : []
    let propertyData = reduce(
      result,
      function (result, object) {
        forEach(object, (value, key) => {
          let newValue = Number(value)
          if (isNaN(newValue)) newValue = value
          ;(result[key] || (result[key] = [])).push(newValue)
        })
        return result
      },
      {},
    )
    forEach(propertyData, (value, key) => {
      propertyData[key] = compact(
        uniqWith(
          propertyData[key],
          (obj, oth) => toLower(obj) === toLower(oth),
        ),
      )
    })

    const [zipValues] = await getZipValues(
      client,
      propertyData ? head(propertyData.zip) : location.postal_code,
    )
    // let propertyData = data
    //   ? data.getZillowPropertyData
    //   : null

    // if (propertyData) {
    //   if (propertyData.files === null)
    //     propertyData.files = { url: [] }
    // }

    let selectedImages = []
    try {
      if (propertyData) {
        if (!isEmpty(propertyData.images)) {
          let images = head(JSON.parse(propertyData.images))
          images = Object.values(images)
          selectedImages = images || []
        }
        if (propertyData.image)
          selectedImages.push(propertyData.image)
      }
      const stockpileCheck = await client.query({
        query: GET_STOCKPILE,
        variables: {
          addressInput: {
            address: propertyData
              ? head(propertyData.address)
              : streetAddress,
            city: propertyData
              ? head(propertyData.city)
              : location.locality,
            county: zipValues ? zipValues.county : '',
            state: propertyData
              ? head(propertyData.state)
              : location.administrative_area_level_1,
          },
        },
        errorPolicy: 'ignore',
      })
      const stockpileValues = stockpileCheck
        ? stockpileCheck.data
        : null
      const { stockedImages } = stockpileValues || {}
      if (stockedImages) {
        selectedImages = concat(
          selectedImages,
          compact([stockpileValues.stockedImages.first]),
          stockpileValues.stockedImages.url || [],
        )
        if (isEmpty(selectedImages))
          selectedImages = concat(
            selectedImages,
            compact([stockpileValues.stockedImages.streetView]),
            compact([stockpileValues.stockedImages.staticMap]),
          )
      }
      if (loc) {
        const MAP_KEY = googleApiKey
        const { lat, lng } = loc
        if (isEmpty(selectedImages)) {
          var service = window.google
            ? new window.google.maps.StreetViewService()
            : 0
          if (service !== 0) {
            await new Promise((resolve, reject) => {
              try {
                service.getPanoramaByLocation(
                  { lat: Number(lat), lng: Number(lng) },
                  50,
                  function (panoData) {
                    if (panoData !== null) {
                      var ManLatLng = panoData.location.latLng
                      const heading =
                        window.google.maps.geometry.spherical.computeHeading(
                          ManLatLng,
                          new window.google.maps.LatLng(
                            Number(lat),
                            Number(lng),
                          ),
                        )
                      selectedImages.push(
                        `https://maps.googleapis.com/maps/api/streetview?size=600x300&location=${lat},${lng}&heading=${heading}&key=${MAP_KEY}`,
                      )
                    }
                    resolve()
                  },
                )
              } catch (error) {
                console.log(error)
              }
            })
          }
          selectedImages.push(
            `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&size=400x400&markers=color:blue%7C${lat},${lng}&key=${MAP_KEY}`,
          )
        }
      }
    } catch (error) {
      console.log(error)
    }

    setCompPropertyInput({
      mainProperty: property._id,
      address: propertyData
        ? head(propertyData.address)
        : streetAddress,
      city: propertyData
        ? head(propertyData.city)
        : location.locality,
      state: propertyData
        ? head(propertyData.state)
        : location.administrative_area_level_1,
      zip: propertyData
        ? head(propertyData.zip)
        : location.postal_code,
      beds: propertyData
        ? maxBy(sum(propertyData.beds), (n) => Number(n)) || 0
        : '',
      baths: propertyData
        ? maxBy(sum(propertyData.baths), (n) => Number(n)) || 0
        : '',
      sqft: propertyData
        ? maxBy(sum(propertyData.sqft), (n) => Number(n)) || 0
        : '',
      year: propertyData ? head(propertyData.yearBuilt) : '',
      estval: propertyData
        ? Number(head(propertyData.soldPrice))
        : '',
      priceAdjustment: 0,
      daysOnMarket: 0,
      rehabLevel: '',
      location: {
        latitude: Number(loc.lat),
        longitude: Number(loc.lng),
      },
    })
    setPropertyData(propertyData)
    setLoader(false)
    pause()
    setSelectedImages(selectedImages)
    setImages([])
    setEdit(false)
    handleOpenAddComp()
  }

  const [potential, setPotential] = useState(false)

  const openEdit = (comp) => {
    if (props.public || props.shared) return
    setCompPropertyInput({
      mainProperty: comp._id,
      address: comp.address,
      city: comp.city,
      state: comp.state,
      zip: comp.zip,
      beds: comp.beds,
      baths: comp.baths,
      sqft: comp.sqft,
      year: comp.year,
      estval: comp.estval,
      priceAdjustment: comp.priceAdjustment,
      daysOnMarket: comp.daysOnMarket,
      rehabLevel: comp.rehabLevel,
      saleDate: comp.saleDate,
      indexTest: comp.indexTest,
      potential: comp.potential,
    })
    setPropertyData(null)
    setImages(comp.images || [])
    setSelectedImages([])
    setEdit(true)
    setPotential(comp.potential)
    handleOpenAddComp()
  }

  const reloadImages = () => {
    setSelectedImages([...selectedImages])
  }

  useEffect(() => {
    const comp = find(
      props.comps,
      (comp) => comp._id === compPropertyInput.mainProperty,
    )
    if (comp) {
      if (!isEqual(images, comp.images)) setImages(comp.images || [])
      setSelectedImages([])
    }
  }, [props.comps])

  const addImages = (files) => {
    let newSelectedImages = selectedImages
    newSelectedImages.push(files)
    setSelectedImages(newSelectedImages)
    reloadImages()
    enqueueSnackbar(`Image uploaded`, {
      variant: 'success',
      autoHideDuration: 3000,
    })
  }

  const {
    // acceptedFiles,
    isDragActive,
    isDragAccept,
    isDragReject,
    getRootProps,
    getInputProps,
  } = useDropzone({
    accept: {
      'image/jpeg': [],
      'image/png': [],
    },
    onDrop: async (acceptedFiles) => {
      // setFiles(acceptedFiles.map(file => Object.assign(file, {
      //   preview: URL.createObjectURL(file)
      // })));

      if (edit) {
        await Promise.all(
          map(acceptedFiles, (file) => {
            const reader = new FileReader()
            return new Promise((resolve, reject) => {
              reader.onload = async () => {
                const image = reader.result
                await imageUpload({
                  variables: {
                    documentId: compPropertyInput.mainProperty,
                    imageUrls: [image],
                    collection: 'compProperty',
                  },
                  refetchQueries: [
                    {
                      query: GET_COMPPROPERTIES,
                      variables: { propertyId: property._id },
                    },
                    {
                      query: GET_PROPERTY,
                      variables: { id: property._id },
                    },
                  ],
                }).then(async ({ data  }) => {
                  // enqueueSnackbar('Image Saved', {
                  //   variant: 'success',
                  //   autoHideDuration: 3000,
                  // })
                  // if (props.handleUpdateMarket) props.handleUpdateMarket()
                  resolve(image)
                })
              }
              reader.readAsDataURL(file)
            })
          }),
        )
        enqueueSnackbar(`Image uploaded`, {
          variant: 'success',
          autoHideDuration: 3000,
        })
      } else {
        map(acceptedFiles, (file) => {
          loadImage(
            file,
            (img) => {
              addImages(img.toDataURL(file.type))
            },
            {
              orientation: true,
              canvas: true,
            },
          )
        })
      }
    },
  })

  // const files = acceptedFiles.map(file => (
  //   <ListItem key={file.path}>
  //     <span>{file.path}</span> <span>{file.size} bytes</span>
  //   </ListItem>
  // ));

  usePlaceAutocomplete(
    'autocomplete',
    {
      types: ['geocode'],
      placeholder: 'Search Property',
      onPlaceChanged: (place) => {
        setPlaceResult(place?.address_components ? place : null)
      },
    },
    openAddCompAddress,
  )

  const handleCompChange = (event) => {
    const { name = '', value = '' } = event.target
    let newInput = { ...compPropertyInput }
    let newValue = value
    //if (type === 'number') newValue = Number(value)
    newInput[name] = newValue
    setCompPropertyInput(newInput)
  }

  const onChangeDate = (date) => {
    let newInput = { ...compPropertyInput }
    newInput['saleDate'] = date
    setCompPropertyInput(newInput)
  }

  const onChangeSlider = (event, value, name) => {
    let newInput = { ...compPropertyInput }
    newInput[name] = value
    setCompPropertyInput(newInput)
  }

  const onChangeDateMenu = (date) => {
    let newDate = toString(date)
    newDate = replace(date, /-/g, '')
    if (newDate) {
      const year = Number(date.substring(0, 4))
      const month = Number(date.substring(4, 6))
      const day = Number(date.substring(6, 8))
      newDate = new Date(year, month - 1, day)
      onChangeDate(newDate)
    }
  }

  const renderInput = (field) => {
    if (field.display) {
      return (
        <Grid
          size={{
            xs: field.xs,
            sm: field.sm,
            md: field.md,
            lg: field.lg,
            xl: field.xl,
          }}
          container
          sx={{
            justifyContent: 'space-between',
          }}
        >
          <Grid>
            <Typography>{field.label}</Typography>
          </Grid>
          <Grid>
            <Typography>
              {field.type === 'dollar'
                ? currencyFormat.format(field.value) || '-'
                : field.value || '-'}
              {field.type === 'percentage' ? '%' : ''}
            </Typography>
          </Grid>
        </Grid>
      )
    } else if (field.type === 'date') {
      return (
        <Grid size={{ xs: field.xs, sm: field.sm }}>
          <DatePicker
            name={field.name}
            label={field.label}
            value={field.value}
            onChange={(date) => onChangeDate(date)}
            format="MM/dd/yyyy"
            slotProps={{
              textField: {
                variant: 'outlined',
                margin: 'dense',
                fullWidth: true,
                style: { borderColor: 'grey' },
                slotProps: {
                  inputLabel: { shrink: true },
                  input: {
                    endAdornment:
                      field.definition &&
                      propertyData &&
                      propertyData[field.definition] &&
                      propertyData[field.definition].length > 1 ? (
                        <InputAdornment
                          position="end"
                          onClick={(event) =>
                            handleDefinition(
                              field.definition,
                              event.target,
                              field.name,
                              field.format,
                            )
                          }
                        >
                          <IconButton
                            size="small" sx={strategyPad5Sx}>
                            <FontAwesomeIcon icon={['fas', 'database']} sx={{ fontSize: "1.265rem !important" }} />
                          </IconButton>
                        </InputAdornment>
                      ) : null,
                  },
                },
              },
            }}
            views={['year', 'month', 'day']}
            openTo="year"
          />
        </Grid>
      )
    } else if (field.type === 'select') {
      return (
        <Grid size={{ xs: field.xs, sm: field.sm }}>
          <Autocomplete
            value={field.value}
            options={field.options}
            onChange={(event, newValue) =>
              handleCompChange({
                target: { name: field.name, value: newValue },
              })
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={field.label}
                variant="outlined"
              />
            )}
          />
        </Grid>
      )
    } else if (field.type === 'currency') {
      return (
        <Grid size={{ xs: field.xs, sm: field.sm }}>
          <NumericFormat
            customInput={TextField}
            thousandSeparator={true}
            prefix={'$'}
            fullWidth={true}
            //isNumericString={true}
            decimalScale={0}
            key={field.name}
            name={field.name}
            value={Math.round(field.value)}
            onValueChange={(values) => {
              const { value } = values
              const event = {
                target: {
                  name: field.name,
                  value: value,
                  type: 'number',
                },
                preventDefault: () => {
                  return null
                },
              }
              handleCompChange(event)
            }}
            type={'text'}
            onFocus={(event) => {
              event.target.select()
            }}
            variant="outlined"
            //margin='dense'
            label={field.label}
            slotProps={{
              input: {
                endAdornment:
                  field.definition &&
                  propertyData &&
                  propertyData[field.definition] &&
                  propertyData[field.definition].length > 1 ? (
                    <InputAdornment
                      position="end"
                      onClick={(event) =>
                        handleDefinition(
                          field.definition,
                          event.target,
                          field.name,
                          field.format,
                        )
                      }
                    >
                      <IconButton size="small" sx={strategyPad5Sx}>
                        <FontAwesomeIcon icon={['fas', 'database']} sx={{ fontSize: "1.265rem !important" }} />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
              },
            }}
          />
        </Grid>
      )
    } else if (field.type === 'number') {
      return (
        <Grid size={{ xs: field.xs, sm: field.sm }}>
          <NumericFormat
            customInput={TextField}
            thousandSeparator={!field.noSeperator}
            fullWidth={true}
            //isNumericString={true}
            decimalScale={field.decimal || 0}
            key={field.name}
            name={field.name}
            value={field.value}
            allowNegative={false}
            onValueChange={(values) => {
              const { value } = values
              const event = {
                target: {
                  name: field.name,
                  value: value,
                  type: 'number',
                },
                preventDefault: () => {
                  return null
                },
              }
              handleCompChange(event)
            }}
            type={'text'}
            onFocus={(event) => {
              event.target.select()
            }}
            variant="outlined"
            //margin='dense'
            label={field.label}
            slotProps={{
              input: {
                endAdornment:
                  field.definition &&
                  propertyData &&
                  propertyData[field.definition] &&
                  propertyData[field.definition].length > 1 ? (
                    <InputAdornment
                      position="end"
                      onClick={(event) =>
                        handleDefinition(
                          field.definition,
                          event.target,
                          field.name,
                          field.format,
                        )
                      }
                    >
                      <IconButton size="small" sx={strategyPad5Sx}>
                        <FontAwesomeIcon icon={['fas', 'database']} sx={{ fontSize: "1.265rem !important" }} />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
              },
            }}
          />
        </Grid>
      )
    } else {
      return (
        <Grid size={{ xs: field.xs, sm: field.sm }}>
          <TextField
            name={field.name}
            fullWidth={true}
            variant="outlined"
            // margin='dense'
            label={field.label}
            value={field.value}
            onChange={handleCompChange}
            slotProps={{
              input: {
                endAdornment:
                  field.definition &&
                  propertyData &&
                  propertyData[field.definition] &&
                  propertyData[field.definition].length > 1 ? (
                    <InputAdornment
                      position="end"
                      onClick={(event) =>
                        handleDefinition(
                          field.definition,
                          event.target,
                          field.name,
                          field.format,
                        )
                      }
                    >
                      <IconButton size="small" sx={strategyPad5Sx}>
                        <FontAwesomeIcon icon={['fas', 'database']} sx={{ fontSize: "1.265rem !important" }} />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
              },
            }}
          />
        </Grid>
      )
    }
  }

  const [backdrop, setBackdrop] = useState(false)

  const [addComp] = useMutation(ADD_COMPPROPERTY)
  // const [getRentalComps] = useMutation(GET_RENTAL_COMPS)
  const [updateComp] = useMutation(UPDATE_COMPPROPERTY)
  const [updateComps] = useMutation(UPDATE_COMPPROPERTIES)
  const [deleteComp] = useMutation(DELETE_COMP)
  const [imageUpload] = useMutation(IMAGE_UPLOAD)
  const [saveAnalysis] = useMutation(SAVE_ANALYSIS)
  const [deleteFile] = useMutation(DELETE_IMAGE)
  const [openDeleteComp, setOpenDeleteComp] = useState(false)

  const [anchorElActionsMenu, setAnchorElActionsMenu] = useState(null)
  const handleClickActionsMenu = (event) => {
    setAnchorElActionsMenu(event.currentTarget)
  }
  const handleCloseActionsMenu = () => {
    setAnchorElActionsMenu(null)
  }

  const toggleDeleteComp = () => {
    setOpenDeleteComp(!openDeleteComp)
  }

  const submitComp =
    (changePotential = false) =>
    () => {
      setLoader(true)
      if (edit) {
        updateComp({
          refetchQueries: [
            {
              query: GET_COMPPROPERTIES,
              variables: {
                propertyId: property._id,
              },
            },
            {
              query: GET_PROPERTY,
              variables: { id: property._id },
            },
          ],
          variables: {
            id: compPropertyInput.mainProperty, //edit had id stored as mainProperty
            compPropertyInput: {
              address: compPropertyInput.address,
              city: compPropertyInput.city,
              state: compPropertyInput.state,
              zip: padStart(compPropertyInput.zip, 5, '0'),
              beds: parseInt(compPropertyInput.beds),
              baths: parseFloat(compPropertyInput.baths),
              sqft: parseInt(compPropertyInput.sqft),
              year: parseInt(compPropertyInput.year),
              estval: parseInt(compPropertyInput.estval),
              daysOnMarket: parseInt(compPropertyInput.daysOnMarket),
              rehabLevel: compPropertyInput.rehabLevel,
              saleDate: compPropertyInput.saleDate
                ? new Date(compPropertyInput.saleDate)
                : null,
              //rentalPrice: parseFloat(rentalPrice),
              priceAdjustment: parseFloat(
                compPropertyInput.priceAdjustment,
              ),
              potential: changePotential ? !potential : potential,
            },
          },
        })
          .then(async ({ data  }) => {
            imageUpload({
              refetchQueries: [
                {
                  query: GET_COMPPROPERTIES,
                  variables: { propertyId: property._id },
                },
                {
                  query: GET_PROPERTY,
                  variables: { id: property._id },
                },
              ],
              variables: {
                documentId: compPropertyInput.mainProperty,
                imageUrls: selectedImages,
                collection: 'compProperty',
              },
            })

            enqueueSnackbar(`Comp updated successfully`, {
              variant: 'success',
              autoHideDuration: 3000,
            })
            handleCloseAddComp()
          })
          .catch((error) => {
            enqueueSnackbar(
              `We couldn't update your comp at this time`,
              {
                variant: 'error',
                autoHideDuration: 3000,
              },
            )
            handleCloseAddComp()
          })
      } else {
        addComp({
          refetchQueries: [
            {
              query: GET_COMPPROPERTIES,
              variables: {
                propertyId: property._id,
              },
            },
            {
              query: GET_PROPERTY,
              variables: { id: property._id },
            },
          ],
          variables: {
            compPropertyInput: {
              mainProperty: compPropertyInput.mainProperty,
              address: compPropertyInput.address,
              city: compPropertyInput.city,
              state: compPropertyInput.state,
              zip: toString(padStart(compPropertyInput.zip, 5, '0')),
              beds: parseInt(compPropertyInput.beds),
              baths: parseFloat(compPropertyInput.baths),
              sqft: parseInt(compPropertyInput.sqft),
              year: parseInt(compPropertyInput.year),
              estval: parseInt(compPropertyInput.estval),
              daysOnMarket: parseInt(compPropertyInput.daysOnMarket),
              rehabLevel: compPropertyInput.rehabLevel,
              saleDate: compPropertyInput.saleDate
                ? new Date(compPropertyInput.saleDate)
                : null,
              //rentalPrice: parseFloat(rentalPrice),
              priceAdjustment: parseFloat(
                compPropertyInput.priceAdjustment,
              ),
              location: compPropertyInput.location,
            },
          },
        })
          .then(async ({ data  }) => {
            imageUpload({
              refetchQueries: [
                {
                  query: GET_COMPPROPERTIES,
                  variables: { propertyId: property._id },
                },
              ],
              variables: {
                documentId: data.addCompProperty._id,
                imageUrls: selectedImages,
                collection: 'compProperty',
              },
            })
            enqueueSnackbar(`Comp added successfully`, {
              variant: 'success',
              autoHideDuration: 3000,
            })

            handleCloseAddComp()
            handleCloseAddCompAddress()
          })
          .catch((error) => {
            enqueueSnackbar(
              `We couldn't add your comp at this time`,
              {
                variant: 'error',
                autoHideDuration: 3000,
              },
            )
            handleCloseAddComp()
            handleCloseAddCompAddress()
          })
      }
    }

  // const pullRentalComps = () => {
  //   const { location = {} } = property
  //   setBackdrop(true)

  //   getRentalComps({
  //     variables: {
  //       propertyId: property._id,
  //       address: property.address,
  //       city: property.city,
  //       state: property.state,
  //       location: {
  //         latitude: location.latitude,
  //         longitude: location.longitude,
  //       },
  //       beds: sum(property.beds),
  //     },
  //     refetchQueries: [
  //       {
  //         query: GET_COMPPROPERTIES,
  //         variables: {
  //           propertyId: property._id,
  //         },
  //       },
  //       {
  //         query: GET_PROPERTY,
  //         variables: { id: property._id },
  //       },
  //     ],
  //   })
  //     .then(async ({ data  }) => {
  //       if (
  //         data.getRentalComps &&
  //         !isEmpty(data.getRentalComps.properties)
  //       )
  //         enqueueSnackbar(`Comps added successfully`, {
  //           variant: 'success',
  //           autoHideDuration: 3000,
  //         })
  //       else
  //         enqueueSnackbar(`We couldn't find any comps at this time`, {
  //           variant: 'error',
  //           autoHideDuration: 3000,
  //         })
  //     })
  //     .catch((error) => {
  //       enqueueSnackbar(`Something went wrong`, {
  //         variant: 'error',
  //         autoHideDuration: 3000,
  //       })
  //     })
  //     .finally(() => {
  //       setBackdrop(false)
  //     })
  // }

  const onDelete = () => {
    deleteComp({
      refetchQueries: [
        {
          query: GET_COMPPROPERTIES,
          variables: {
            propertyId: property._id,
          },
        },
        {
          query: GET_PROPERTY,
          variables: { id: property._id },
        },
      ],
      variables: {
        id: compPropertyInput.mainProperty, //edit stores _id as mainProperty
      },
    })
      .then(async ({ data  }) => {
        enqueueSnackbar(`Comp Deleted`, {
          variant: 'success',
          autoHideDuration: 3000,
        })
        handleCloseAddComp()
        toggleDeleteComp()
      })
      .catch((error) => {
        enqueueSnackbar(`Error Deleting Comp`, {
          variant: 'error',
          autoHideDuration: 3000,
        })
        handleCloseAddComp()
        toggleDeleteComp()
      })
  }

  const compFields = [
    // {
    //   type: 'text',
    //   name: 'address',
    //   label: 'Address',
    //   value: compPropertyInput.address,
    //   definition: 'address',
    //   xs: 12,
    // },
    {
      type: 'text',
      name: 'city',
      label: 'City',
      value: compPropertyInput.city,
      definition: 'city',
      xs: 12,
    },
    {
      type: 'autocomplete',
      name: 'state',
      label: 'State',
      options: statesShort(),
      value: compPropertyInput.state,
      definition: 'state',
      xs: 6,
    },
    {
      type: 'number',
      name: 'zip',
      label: 'Zip',
      value: compPropertyInput.zip,
      definition: 'zip',
      noSeperator: true,
      xs: 6,
    },
    {
      type: 'number',
      name: 'beds',
      label: 'Beds',
      value: compPropertyInput.beds,
      definition: 'beds',
      xs: 6,
    },
    {
      type: 'number',
      name: 'baths',
      label: 'Baths',
      value: compPropertyInput.baths,
      definition: 'baths',
      decimal: 2,
      xs: 6,
    },
    {
      type: 'number',
      name: 'sqft',
      label: 'Sqft',
      value: compPropertyInput.sqft,
      definition: 'sqft',
      format: numberFormat,
      xs: 6,
    },
    {
      type: 'number',
      name: 'year',
      label: 'Year',
      noSeperator: true,
      value: compPropertyInput.year,
      definition: 'yearBuilt',
      xs: 6,
    },
  ]

  const compFinancialFields = [
    {
      type: 'currency',
      name: 'estval',
      label: 'Sold Price',
      value: compPropertyInput.estval,
      definition: 'price',
      format: currencyFormat,
      xs: 12,
      sm: 6,
    },
    {
      type: 'date',
      name: 'saleDate',
      label: 'Date Sold',
      value: compPropertyInput.saleDate
        ? new Date(compPropertyInput.saleDate).toLocaleDateString(
            'en-US',
          )
        : null,
      definition: 'soldDate',
      xs: 12,
      sm: 6,
    },
    {
      type: 'number',
      name: 'daysOnMarket',
      label: 'Days on Market',
      value: compPropertyInput.daysOnMarket,
      xs: 12,
      sm: 6,
    },
    {
      type: 'select',
      name: 'rehabLevel',
      label: 'Rehab Level',
      value: compPropertyInput.rehabLevel,
      xs: 12,
      sm: 6,
      options: map(REHAB_LEVELS, (rehab) => rehab.value),
    },
  ]

  const widgetsCarousels1B = {
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    nextArrow: <SliderArrowNext />,
    prevArrow: <SliderArrowPrev />,
  }

  const [selected, setSelected] = useState([])

  const [search, setSearch] = useState('')
  const [searchedComps, setSearchedComps] = useState(comps)

  const [filtered, setFiltered] = useState(false)
  const [filteredComps, setFilteredComps] = useState(comps)

  const [showMap, setShowMap] = useState(true)
  const [showAnalytics, setShowAnalytics] = useState(true)

  const [searchStatus3, setSearchStatus3] = useState(false)
  const toggleSearch3 = () => setSearchStatus3(!searchStatus3)

  const { page, setPage } = props
  const handleChange = (event, value) => {
    localStorage.setItem(
      `${property._id}-comps-rental-card-page`,
      value,
    )
    setPage(value)
  }

  const [bulkSetCompDialog, setBulkSetCompDialog] = useState(false)
  const [bulkSetPotentialDialog, setBulkSetPotentialDialog] =
    useState(false)

  const handleBulkDialog = (potential = false) => {
    setLoader(true)
    updateComps({
      variables: {
        ids: selected,
        compPropertyInput: { potential },
      },
      refetchQueries: [
        {
          query: GET_COMPPROPERTIES,
          variables: { propertyId: property._id },
        },
      ],
    }).then(async ({ data  }) => {
      setLoader(false)
      setSelected([])
      closeBulk()
    })
  }

  const closeBulk = () => {
    setBulkSetCompDialog(false)
    setBulkSetPotentialDialog(false)
  }

  const compare = intersection(
    map(searchedComps, (comp) => comp._id),
    selected,
  )

  let shownComps =
    search && filtered
      ? intersectionBy(searchedComps, filteredComps, '_id')
      : search
        ? [...searchedComps]
        : filtered && filteredComps
          ? [...filteredComps]
          : [...comps] || []

  const actualSelected =
    filter(shownComps, (comp) => includes(selected, comp._id))
      .length > 0

  const compValues = map(comps, (comp) => {
    return {
      _id: comp._id,
      rentalPrice: comp.rentalPrice,
      occupancyRate: comp.occupancyRate,
    }
  })

  const shownCompID = map(shownComps, (comp) => comp._id)
  const shownCompValues = filter(compValues, (value) =>
    includes(shownCompID, value._id),
  )

  const selectComp = (id) => (event) => {
    event.preventDefault()
    let newSelect = [...selected]
    if (includes(newSelect, id)) pull(newSelect, id)
    else newSelect.push(id)
    setSelected(newSelect)
  }

  const selectAll = () => {
    if (compare.length < comps.length)
      setSelected(map(comps, (comp) => comp._id))
    else setSelected([])
  }

  const [isSavedFilter, setIsSavedFilter] = useState(false)

  const getFilteredComps = (filtered) => {
    setFilteredComps(filtered)
    setFiltered(true)
  }

  useEffect(() => {
    const getSearchResults = (string) => {
      if (search === string) return null
      const words = split(string, ' ')
      const searchFilters = map(
        words,
        (word) => new RegExp(toLower(word)),
      )
      const filtered = filter(comps, (comp) => {
        const { createdBy } = comp
        const profile = createdBy
          ? createdBy.profile
          : { firstname: '', lastname: '' }
        return every(
          searchFilters,
          (searchFilter) =>
            searchFilter.test(toLower(comp.address)) ||
            searchFilter.test(toLower(comp.city)) ||
            searchFilter.test(toLower(comp.state)) ||
            searchFilter.test(toLower(comp.zip)) ||
            searchFilter.test(toLower(comp.sqft)) ||
            searchFilter.test(toLower(comp.description)) ||
            searchFilter.test(toLower(profile.firstname)) ||
            searchFilter.test(toLower(profile.lastname)),
        )
      })
      if (isEqual(filtered, searchedComps)) return null
      setSearch(string)
      setSearchedComps(filtered)
    }
    getSearchResults(search)
  }, [comps, search, searchedComps])

  const count = ceil(shownComps.length / 24)
  if (page > count && count) setPage(count || 1)

  return (
    <>
      <Grid container spacing={2} sx={strategyPagePadSx}>
        <Grid size={12}>
          <Collapse
            in={Boolean(showMenu)}
            sx={{
              width: '100%',
              mb: 2,
            }}
          >
            <Card variant="outlined"
              sx={{
              display: 'block',
              textAlign: 'center',
              '@media (min-width: 576px)': { display: 'flex' },
              '@media (min-width: 768px)': { textAlign: 'left' },
              p: '1.5rem',
              alignItems: 'center',
              backgroundColor: '#f8f9ff',
              justifyContent: 'space-between',
              flexDirection: 'row',
              width: '100%',
              maxWidth: '100%',
              }}
              >
              {hiddenUp ? null : (
                <div
                  sx={strategyPositionCloseSx}
                >
                  <Typography
                    variant="subtitle2"
                    onClick={() => handleMenu()}
                  >
                    Hide Menu
                  </Typography>
                </div>
              )}
              <Grid
                container
                spacing={1}
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  width: "100%",
                  maxWidth: "100%",
                  minWidth: 0,
                  alignItems: "center",
                  rowGap: 1,
                }}
              >
                <Grid size="auto">
                  {!props.shared && (
                    <Grid
                      container
                      sx={{
                        alignItems: 'center',
                      }}
                    >
                      <Grid>
                        <Checkbox
                          checked={compare.length > 0}
                          indeterminate={
                            compare.length < shownComps.length &&
                            compare.length > 0
                          }
                          onClick={selectAll}
                        />
                      </Grid>
                      <Grid>
                        <Typography>
                          Select All ({shownComps.length })
                        </Typography>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
                {!props.shared && (
                  <Grid size="auto" sx={{
                    display: "none",
                    "@media (min-width: 576px)": { display: "block" },
                    alignSelf: "stretch",
                    width: "1px",
                    minHeight: 26,
                    mx: "1rem",
                    bgcolor: "#4f5062",
                    opacity: 0.3,
                    flexShrink: 0,
                  }} />
                )}
                <Box
                  sx={[
                    {
                      position: "relative",
                      flex: "1 1 160px",
                      minWidth: 140,
                      maxWidth: 280,
                      "& .MuiTextField-root": { width: "100%", maxWidth: "100%" },
                    },
                    {
                      display: 'flex',
                      justifyContent: 'center',
                      py: { xs: '1rem', md: 0 },
                    },
                  ]}
                >
                  <Box
                    sx={[
                      {
                        position: "relative",
                        transition: "all 0.2s ease-in-out",
                        "& .MuiOutlinedInput-notchedOutline": { borderWidth: 2 },
                        "& .MuiTextField-root": { borderWidth: 2, transition: "all 0.2s ease-in-out", background: "#f8f9ff" },
                        "&:hover .MuiTextField-root": { background: "#f4f5fd" },
                        "&.is-active .MuiTextField-root": { background: "#fff", borderColor: "#368cff" },
                      },
                      {
                        width: '100%',
                        '& .MuiTextField-root': {
                          width: '100%',
                          maxWidth: '100%',
                        },
                      },
                    ]}
                  >
                    <TextField
                      variant="outlined"
                      size="small"
                      sx={{ backgroundColor: "#fff" }}
                      value={props.search}
                      onChange={(event) =>
                        setSearch(event.target.value)
                      }
                      placeholder={'Search these rental comps'}
                      id="input-with-icon-textfield22-3"
                      onFocus={toggleSearch3}
                      onBlur={toggleSearch3}
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">
                              <FontAwesomeIcon
                                icon={['fas', 'search']}
                                sx={strategyMutedGraySx}
                              />
                            </InputAdornment>
                          ),
                        },
                      }}
                    />
                  </Box>
                </Box>
                {activeTab === '1' && (
                  <Grid
                    size="auto"
                    sx={{ ml: 'auto', mr: 0.5, flexShrink: 0 }}
                  >
                    <Select
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={ordering}
                      onChange={(event) =>
                        setOrdering(event.target.value)
                      }
                      displayEmpty
                    >
                      {map(sortingChoices, (choice) => (
                        <MenuItem
                          key={choice.name}
                          value={choice.name}
                        >
                          {choice.title}
                        </MenuItem>
                      ))}
                      <MenuItem key={'unselected'} value={''}>
                        Added - new to old
                      </MenuItem>
                    </Select>
                  </Grid>
                )}
                <Grid
                  size="auto"
                  sx={{
                    flexShrink: 0,
                    ...(activeTab === '1' ? {} : { ml: 'auto'  }),
                  }}
                >
                  <Grid
                    container
                    spacing={1}
                    wrap="nowrap"
                    sx={{
                      alignItems: 'center',
                    }}
                  >
                    <Grid>
                      <ButtonGroup
                        variant="contained"
                        color="primary"
                        sx={{
                          boxShadow: "0 0.25rem 0.55rem rgba(54, 140, 255, 0.35)",
                          overflow: "hidden",
                          borderRadius: "0.2rem",
                          "& .MuiButton-root": {
                            minWidth: "40px !important",
                            width: 40,
                            height: 40,
                            p: 0,
                            backgroundImage: "none",
                            borderColor: "rgba(255,255,255,0.22) !important",
                            boxShadow: "none",
                          },
                          "& .MuiButton-root:not(.active)": {
                            color: "#fff",
                            backgroundColor: "#368cff",
                            "&:hover": { backgroundColor: "#368cff", color: "#fff" },
                            "& .MuiSvgIcon-root": { color: "#fff" },
                          },
                        }}
                      >
                        <Tooltip title="Card View">
                          <Button
                            onClick={() => {
                              setActiveTab('1')
                              localStorage.setItem('view', '1')
                            }}
                            {...searchToolbarIconButtonProps(activeTab === '1')}
                          >
                            <Box component="span" sx={[{
                              height: "20px !important",
                              width: "20px !important",
                              lineHeight: "20px !important",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              p: 0,
                            }, { display: "inline-flex" }]}>
                              <GridOnTwoTone />
                            </Box>
                          </Button>
                        </Tooltip>
                      </ButtonGroup>
                    </Grid>
                    <Grid>
                      <ButtonGroup
                        variant="contained"
                        color="primary"
                        sx={{
                          boxShadow: "0 0.25rem 0.55rem rgba(54, 140, 255, 0.35)",
                          overflow: "hidden",
                          borderRadius: "0.2rem",
                          "& .MuiButton-root": {
                            minWidth: "40px !important",
                            width: 40,
                            height: 40,
                            p: 0,
                            backgroundImage: "none",
                            borderColor: "rgba(255,255,255,0.22) !important",
                            boxShadow: "none",
                          },
                          "& .MuiButton-root:not(.active)": {
                            color: "#fff",
                            backgroundColor: "#368cff",
                            "&:hover": { backgroundColor: "#368cff", color: "#fff" },
                            "& .MuiSvgIcon-root": { color: "#fff" },
                          },
                        }}
                      >
                        <Tooltip title="Show Analytics">
                          <Button
                            onClick={() => {
                              setShowAnalytics(!showAnalytics)
                            }}
                            {...searchToolbarIconButtonProps(showAnalytics)}
                          >
                            <Box component="span" sx={[{
                              height: "20px !important",
                              width: "20px !important",
                              lineHeight: "20px !important",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              p: 0,
                            }, { display: "inline-flex" }]}>
                              <PollTwoTone />
                            </Box>
                          </Button>
                        </Tooltip>
                        <Tooltip title="Show Map">
                          <Button
                            onClick={() => {
                              setShowMap(!showMap)
                            }}
                            {...searchToolbarIconButtonProps(showMap)}
                          >
                            <Box component="span" sx={[{
                              height: "20px !important",
                              width: "20px !important",
                              lineHeight: "20px !important",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              p: 0,
                            }, { display: "inline-flex" }]}>
                              <RoomTwoTone />
                            </Box>
                          </Button>
                        </Tooltip>
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Collapse>
        </Grid>
        <Grid size={12}>
          <Grid container spacing={2}>
            {showMap && (
              <Grid size={{ xs: 12, xl: 6 }}>
                <Card>
                  {/* {!openAddCompAddress && (<Map properties={[property]} comps={shownComps} propertyPage streetView={false} />)} */}
                  <Map
                    properties={[property]}
                    comps={stableSort(
                      shownComps,
                      getSorting(order, orderByTarget),
                    )}
                    propertyPage
                    streetView={false}
                    hide={openAddCompAddress}
                    openComp={openEdit}
                    shared={props.shared || props.public}
                  />
                </Card>
              </Grid>
            )}
            {showAnalytics && (
              <Grid size={{ xs: 12, xl: 6 }}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, lg: 6 }}>
                    <Card variant="outlined" sx={[strategyFullHeight100Sx, { p: '1.5rem' }]}>
                      <Box sx={[{ textTransform: 'uppercase', mt: '0.5rem', }, { fontSize: "0.875rem !important" }, strategyDarkTextSx]}>
                        Comps Properties
                      </Box>
                      <Box sx={{ my: '0.5rem' }}>
                        <Box
                          sx={{
                            display: 'flex',
                            py: '1.5rem',
                            alignItems: 'center',
                          }}
                        >
                          <Box sx={[strategyIconBlueBgSx, {
                            height: "60px !important",
                            width: "60px !important",
                            lineHeight: "60px !important",
                            display: "inline-flex !important",
                            alignItems: "center",
                            justifyContent: "center",
                            p: 0,
                            border: 0,
                            borderRadius: "0.65rem",
                            flexShrink: 0,
                            color: "#fff",
                            textAlign: "center",
                            mr: "1rem",
                            boxShadow: "0 0.313rem 0.8rem rgba(65, 145, 255, 0.5), 0 0.126rem 0.225rem rgba(65, 145, 255, 0.3) !important",
                          }]}>
                            <HomeIcon sx={strategyIconSize40Sx} />
                          </Box>
                          <Box sx={[{ ml: '0.25rem' }, { fontSize: "2.5rem", fontWeight: "300", lineHeight: "1.2" }]}>
                            {shownComps.length}
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            color: 'rgba(7, 9, 25, 0.5)',
                            mb: '0.5rem',
                          }}
                        >
                          The number of rental properties comparable
                          to {property.address}.
                        </Box>
                      </Box>
                    </Card>
                  </Grid>
                  <Grid size={{ xs: 12, lg: 6 }}>
                    <Card variant="outlined" sx={[strategyFullHeight100Sx, { p: '1.5rem' }]}>
                      <Box sx={[{ textTransform: 'uppercase', mt: '0.5rem', }, { fontSize: "0.875rem !important" }, strategyDarkTextSx]}>
                        Average Daily Rate
                      </Box>
                      <Box sx={{ my: '0.5rem' }}>
                        <Box
                          sx={{
                            display: 'flex',
                            py: '1.5rem',
                            alignItems: 'center',
                          }}
                        >
                          <Box sx={[{ fontWeight: 700, ml: '0.25rem' }, { fontSize: "1.7rem", fontWeight: "300", lineHeight: "1.2" }]}>
                            <CountUp
                              start={0}
                              end={
                                isEmpty(shownCompValues)
                                  ? 0
                                  : meanBy(
                                      filter(
                                        shownCompValues,
                                        'rentalPrice',
                                      ),
                                      'rentalPrice',
                                    )
                              }
                              duration={1}
                              separator=","
                              delay={1}
                              decimals={1}
                              decimal="."
                              prefix="$"
                            />
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            color: 'rgba(7, 9, 25, 0.5)',
                            mb: '0.5rem',
                          }}
                        >
                          The average daily rate of the rental comp
                          properties below
                        </Box>
                      </Box>
                    </Card>
                  </Grid>
                  <Grid size={{ xs: 12, lg: 6 }}>
                    <Card variant="outlined"
                      data-tour="comps-step-1" sx={[strategyFullHeight100Sx, { p: '1.5rem' }]}>
                      <Box sx={[{ textTransform: 'uppercase', mt: '0.5rem', }, { fontSize: "0.875rem !important" }, strategyDarkTextSx]}>
                        Average Occupancy Rate
                      </Box>
                      <Box sx={{ my: '0.5rem' }}>
                        <Box
                          sx={{
                            display: 'flex',
                            py: '1.5rem',
                            alignItems: 'center',
                          }}
                        >
                          <Box sx={[strategyIconBlueBgSx, {
                            height: "60px !important",
                            width: "60px !important",
                            lineHeight: "60px !important",
                            display: "inline-flex !important",
                            alignItems: "center",
                            justifyContent: "center",
                            p: 0,
                            border: 0,
                            borderRadius: "0.65rem",
                            flexShrink: 0,
                            color: "#fff",
                            textAlign: "center",
                            mr: "1rem",
                            boxShadow: "0 0.313rem 0.8rem rgba(65, 145, 255, 0.5), 0 0.126rem 0.225rem rgba(65, 145, 255, 0.3) !important",
                          }]}>
                            <LinearScaleIcon
                              sx={strategyIconSize40Sx}
                            />
                            {/* <FontAwesomeIcon
                            icon={['far', 'envelope']}
                          /> */}
                          </Box>
                          <Box sx={[{ fontWeight: 700, ml: '0.25rem' }, { fontSize: "2.5rem", fontWeight: "300", lineHeight: "1.2" }]}>
                            <CountUp
                              start={0}
                              end={
                                isEmpty(shownCompValues)
                                  ? 0
                                  : meanBy(
                                      filter(
                                        shownCompValues,
                                        'occupancyRate',
                                      ),
                                      'occupancyRate',
                                    ) * 100
                              }
                              duration={1}
                              separator=","
                              delay={1}
                              decimals={2}
                              decimal="."
                              suffix="%"
                            />
                          </Box>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          color: 'rgba(7, 9, 25, 0.5)',
                          mb: '0.5rem',
                        }}
                      >
                        The average rate these rental comps are
                        occupied
                      </Box>
                    </Card>
                  </Grid>
                  {/* <Grid size={{xs: 12, lg: 6}}>
                  <Card sx={strategyFullHeight100Sx}>
                    <div>
                      Average Property Value
                    </div>
                    <div>
                      <div>
                        <div>
                          <SquareFootIcon sx={strategyIconSize40Sx} />
                        </div>
                        <div>
                          <CountUp
                            start={0}
                            end={isEmpty(shownCompValues) ? 0 : meanBy(filter(shownCompValues, 'propertyPrice'), 'propertyPrice']}
                            duration={1}
                            separator=","
                            delay={1}
                            decimals={2}
                            decimal="."
                            prefix="$"
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      The average property value of the rental comp properties below.
                    </div>
                  </Card>
                </Grid> */}
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid size={12}>
          {activeTab === '1' && comps.length > 0 && (
            <>
              <Grid
                container
                direction="column" sx={strategyMarginTop10OnlySx}>
                <Grid sx={{ mt: 2, mb: 1, overflow: 'visible' }}>
                  <Typography
                    variant="h5"
                    sx={{ lineHeight: 1.4, overflow: 'visible' }}
                  >
                    Comparable Properties
                  </Typography>
                </Grid>
                <Grid>
                  {compact(shownComps).length > 0 ? (
                    <>
                      <Grid
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 380px), 1fr))",
                          gap: 4,
                          width: "100%",
                          mt: "10px",
                        }}
                      >
                        {map(
                          slice(
                            stableSort(
                              compact(shownComps),
                              getSorting(order, orderByTarget),
                            ),
                            (page - 1) * 24,
                            page * 24,
                          ),
                          (comp, index) => (
                            <RentalCompsCard
                              key={comp?._id || `rental-comp-${index}`}
                              comp={comp}
                              index={(page - 1) * 24 + index}
                              property={property}
                              openEdit={openEdit}
                              selected={selected}
                              selectComp={selectComp}
                              shared={props.shared || props.public}
                            />
                          ),
                        )}
                      </Grid>
                      {Boolean(count) && shownComps.length > 0 && (
                        <Grid size={12}>
                          <Box
                            sx={{
                              p: '1rem',
                              display: 'flex',
                              justifyContent: 'center',
                            }}
                          >
                            <Pagination size="small" count={count} page={page} onChange={handleChange} shared={props.shared || props.public} />
                          </Box>
                        </Grid>
                      )}
                    </>
                  ) : (
                    <AllPropertiesFiltered />
                  )}
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
      {showCompsSkeleton && (
        <Grid size={12}>
          <Grid container spacing={4} sx={strategyMarginTop10Sx}>
            {activeTab === '2' ? (
              <PropertyListSkeleton rowCount={8} />
            ) : (
              <PropertyCardSkeleton count={6} variant="comps" />
            )}
          </Grid>
        </Grid>
      )}
      {/* {!props.public && !props.shared && isEmpty(props.comps) && (
        <Grid>
          <div>
            <div>
              <div
              >
                <CompareIcon
                  sx={strategyAvatarBlueLargeSx}
                />
              </div>
            </div>
            <h4>
              Lets Find Some Rental Comps
            </h4>
            <p>
              Use Housefolios to help you find comparable rental
              properties nearby
            </p>
            <div>
              <Button
                data-tour="comps-step-3"
                variant="contained"
                size="small"
                onClick={pullRentalComps} sx={{ backgroundColor: '#1cc943', color: 'white' }}>
                <AddTwoToneIcon
                  style={strategyIconGap10Style}
                />
                Get Rental Comps
              </Button>
            </div>
            {backdrop && (
              <Backdrop
                open={backdrop} sx={{ color: '#fff', zIndex: 100000 }}>
                <CircularProgress color="inherit" />
              </Backdrop>
            )}
          </div>
        </Grid>
      )} */}
      <Collapse
        in={selected.length > 0} sx={strategyFixedBottomBarSx}>
        <Alert
          icon={false}
          sx={{
            display: 'block',
            backgroundColor: '#253152',
            color: '#fff',
            border: 'none',
            borderRadius: '0.65rem',
            boxShadow:
              '0 0.313rem 0.8rem rgba(7, 9, 25, 0.3), 0 0.126rem 0.225rem rgba(7, 9, 25, 0.1)',
            overflow: 'hidden',
            '& .MuiAlert-message': {
              width: '100%',
              color: '#fff',
            },
            '& .MuiTypography-root': {
              color: '#fff',
            },
          }}
        >
          {/* <Typography sx={{ color: 'white', fontWeight: 600 }}>You have unsaved changes</Typography> */}
          <Grid
            container
            direction="row"
            wrap="nowrap"
            sx={strategyOverflowScrollSx}
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Grid>
              <Grid
                container
                wrap="nowrap"
                sx={{
                  alignItems: 'center',
                }}
              >
                <Grid>
                  <Tooltip title="Deselect Comps">
                    <IconButton
                      onClick={() => setSelected([])}
                      size="large"
                    >
                      <FontAwesomeIcon
                        icon={['fas', 'xmark']}
                        sx={strategyWhiteTextSx}
                      />
                    </IconButton>
                  </Tooltip>
                </Grid>
                <Grid>
                  <Typography
                    sx={{
                      whiteSpace: 'nowrap',
                      mr: '20px',
                      color: '#fff',
                      fontWeight: 600,
                    }}
                  >
                    {selected.length} selected
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid sx={strategyDrawerLegendSx}>
              <Grid container wrap="nowrap">
                <Grid>
                  <DeleteComps
                    bulkActionsNotifications={true}
                    selected={selected}
                    setSelected={setSelected}
                    propertyId={property._id}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid disabled />
          </Grid>
        </Alert>
      </Collapse>
      <Dialog
        open={openAddCompAddress}
        onClose={handleCloseAddCompAddress}
        maxWidth="sm"
        fullWidth={true}
        slotProps={{
          paper: { sx: { overflow: 'visible' } },
        }}
      >
        <BlockUi
          blocking={loader}
          loader={
            <PacmanLoader color={'var(--primary)'} loading={true} />
          }
          message={
            <Box sx={{ color: '#368cff' }}>
              <p>Connecting</p>
              <p>
                {(((minutes * 60 + seconds) / 120) * 100).toFixed(1)}%
                Complete
              </p>
            </Box>
          }
        >
          <DialogTitle>Add Comp Property</DialogTitle>
          <DialogContent sx={{ overflow: 'visible' }} data-hf="places-dialog-content">
            <Box data-hf-place-field="" sx={{
              width: "100%",
              position: "relative",
              minHeight: 40,
              marginTop: 0,
              "& > input": { display: "none" },
            }}>
              <input
                id="autocomplete"
                type="text"
                placeholder="Search Property"
                autoFocus
                aria-label="Search Property"
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <ApolloConsumer>
              {(client) => (
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!placeResult}
                  onClick={() => searchForComp(client)}
                >
                  Search
                </Button>
              )}
            </ApolloConsumer>
          </DialogActions>
        </BlockUi>
        {/* <Card>
          <CardHeader title="Add Comp Property" />
          <CardContent>
            <TextField
              id="autocomplete"
              label="Search Property"
              placeholder="Address"
              fullWidth={true}
            />
          </CardContent>
          <Divider />
          <CardActions>
            <Typography sx={strategyFlexGrowSx} />
            <ApolloConsumer>
              {client => (
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!placeResult}
                  onClick={() => searchForComp(client)}>
                  Search
                </Button>
              )}
            </ApolloConsumer>
          </CardActions>
        </Card> */}
      </Dialog>
      <Dialog
        open={openAddComp}
        onClose={handleCloseAddComp}
        maxWidth="md"
        fullWidth={true}
      >
        <DialogTitle id="form-dialog-title">
          {edit ? 'Edit Comp' : 'Add Comp'}{' '}
          {edit && (
            <Avatar sx={{
                height: 30,
                width: 30,
                position: 'absolute',
                top: 15,
                right: 20,
                backgroundColor: compMarkerColor(
                  compPropertyInput.potential,
                ),
                color: '#fff',
              }}>
              {compPropertyInput.indexTest}
            </Avatar>
          )}
        </DialogTitle>
        {/* <Grid> */}

        {/* </Grid> */}
        <DialogContent sx={{ p: '1.5rem' }}>
          <BlockUi
            blocking={loader}
            loader={
              <PacmanLoader color={'var(--primary)'} loading={true} />
            }
            message={<Box sx={{ color: '#368cff' }}>Saving Comp</Box>}
          >
            <Grid container direction="row">
              <Grid size={{ sm: 12 }} sx={strategyPad10Sx}>
                <Grid container direction="column">
                  <Slider1 {...widgetsCarousels1B} sx={{ flexShrink: 0, width: "100%" }}>
                    {!isEmpty(images) &&
                      map(images, (image) => (
                        <div
                          onClick={(event) => {
                            event.stopPropagation()
                          }}
                        >
                          <Card sx={[strategyCompCardSx, { boxShadow: 'none' }]}>
                            <Grid
                              container
                              direction="column" sx={[strategyFullHeight100Sx, {
                                justifyContent: 'center',
                              }]}>
                              <Grid>
                                <Box sx={[strategyTransparentRelCenterSx, {
                                  position: "relative",
                                  borderTopLeftRadius: "inherit",
                                  borderTopRightRadius: "inherit",
                                  "& .img-wrapper-overlay": {
                                    width: "100%",
                                    height: "100%",
                                    transition: "all 0.2s ease-in-out",
                                    opacity: 0,
                                    visibility: "hidden",
                                    position: "absolute",
                                    left: 0,
                                    top: 0,
                                    boxShadow: "inset 0 0 2.3rem 0.5rem #000",
                                    display: "flex",
                                    alignItems: "center",
                                    alignContent: "center",
                                    color: "#fff",
                                    borderTopLeftRadius: "inherit",
                                    borderTopRightRadius: "inherit",
                                    "@media (max-width: 575.98px)": {
                                      "& + img": { width: "100% !important" },
                                    },
                                    "& .overlay-btn-wrapper": {
                                      position: "relative",
                                      zIndex: 3,
                                      textAlign: "center",
                                      width: "100%",
                                    },
                                    "&::before": {
                                      zIndex: 2,
                                      position: "absolute",
                                      left: 0,
                                      top: 0,
                                      content: "\"\"",
                                      width: "100%",
                                      height: "100%",
                                      transition: "all 0.2s ease-in-out",
                                      background: "#000",
                                      opacity: 0.75,
                                    },
                                  },
                                  "& .img-wrapper-overlay--visible": {
                                    visibility: "visible",
                                    opacity: 1,
                                    position: "relative",
                                    zIndex: 5,
                                  },
                                  "& .card-badges": { zIndex: 5 },
                                  "a&": {
                                    display: "block",
                                    overflow: "hidden",
                                    "&:hover .img-wrapper-overlay": { opacity: 1, visibility: "visible" },
                                  },
                                }]}>
                                  <Box sx={[{ backgroundImage: 'url(' + image.url_small + ')', height: 325, display: 'flex', justifyContent: 'center', alignItems: 'center', }, { backgroundSize: "contain", backgroundPosition: "center", backgroundRepeat: "no-repeat" }]}>
                                    <Box component="img" src={image.url} alt="..." loading="lazy" sx={[strategyCompImgSx, { borderRadius: '0.65rem' }, { flexShrink: 0, width: "100%" }]}/>
                                  </Box>
                                </Box>
                                <Avatar
                                  onClick={(event) =>
                                    handleEditImageMoreVertOpen(
                                      event,
                                      image,
                                    )
                                  } sx={strategyAbsTopRightPinkSx}>
                                  <MoreVertIcon sx={strategyWhiteTextSx}/>
                                </Avatar>
                                {/* <Avatar
                              onClick={toggleOpenDeleteImage(image._id)} sx={strategyAbsTopRightPinkSx}>
                              <DeleteTwoTone sx={strategyWhiteTextSx}/>
                            </Avatar> */}
                              </Grid>
                            </Grid>
                          </Card>
                        </div>
                      ))}
                    {!isEmpty(selectedImages) &&
                      map(selectedImages, (image) => (
                        <div
                          onClick={(event) => {
                            event.stopPropagation()
                          }}
                        >
                          <Card sx={[strategyCompCardSx, { boxShadow: 'none' }]}>
                            <Grid
                              container
                              direction="column" sx={[strategyFullHeight100Sx, {
                                justifyContent: 'center',
                              }]}>
                              <Grid>
                                <Box sx={[strategyTransparentCenterSx, {
                                  position: "relative",
                                  borderTopLeftRadius: "inherit",
                                  borderTopRightRadius: "inherit",
                                  "& .img-wrapper-overlay": {
                                    width: "100%",
                                    height: "100%",
                                    transition: "all 0.2s ease-in-out",
                                    opacity: 0,
                                    visibility: "hidden",
                                    position: "absolute",
                                    left: 0,
                                    top: 0,
                                    boxShadow: "inset 0 0 2.3rem 0.5rem #000",
                                    display: "flex",
                                    alignItems: "center",
                                    alignContent: "center",
                                    color: "#fff",
                                    borderTopLeftRadius: "inherit",
                                    borderTopRightRadius: "inherit",
                                    "@media (max-width: 575.98px)": {
                                      "& + img": { width: "100% !important" },
                                    },
                                    "& .overlay-btn-wrapper": {
                                      position: "relative",
                                      zIndex: 3,
                                      textAlign: "center",
                                      width: "100%",
                                    },
                                    "&::before": {
                                      zIndex: 2,
                                      position: "absolute",
                                      left: 0,
                                      top: 0,
                                      content: "\"\"",
                                      width: "100%",
                                      height: "100%",
                                      transition: "all 0.2s ease-in-out",
                                      background: "#000",
                                      opacity: 0.75,
                                    },
                                  },
                                  "& .img-wrapper-overlay--visible": {
                                    visibility: "visible",
                                    opacity: 1,
                                    position: "relative",
                                    zIndex: 5,
                                  },
                                  "& .card-badges": { zIndex: 5 },
                                  "a&": {
                                    display: "block",
                                    overflow: "hidden",
                                    "&:hover .img-wrapper-overlay": { opacity: 1, visibility: "visible" },
                                  },
                                }]}>
                                  <Box sx={[{ backgroundImage: 'url(' + image.url_small + ')', height: 325, display: 'flex', justifyContent: 'center', alignItems: 'center', }, { backgroundSize: "contain", backgroundPosition: "center", backgroundRepeat: "no-repeat" }]}>
                                    <Box component="img" src={image.url} alt="..." loading="lazy" sx={[strategyCompImgSx, { borderRadius: '0.65rem' }, { flexShrink: 0, width: "100%" }]}/>
                                  </Box>
                                </Box>
                                <Avatar
                                  onClick={() =>
                                    handleOpenEditImage(image)
                                  } sx={{
                                    position: 'absolute',
                                    top: 10,
                                    right: 10,
                                    // backgroundColor: 'primary',
                                  }}>
                                  <EditIcon sx={strategyWhiteTextSx}/>
                                </Avatar>
                              </Grid>
                            </Grid>
                          </Card>
                        </div>
                      ))}
                  </Slider1>
                  <Menu
                    anchorEl={editImageMoreVert}
                    keepMounted
                    open={Boolean(editImageMoreVert)}
                    onClose={handleEditImageMoreVertClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    slotProps={{ list: { sx: { p: 0 } } }}
                  >
                    <Box sx={{ p: '0.5rem' }}>
                      <List component="div" sx={[{
                        width: "100%",
                        "& .MuiListItem-root, & .MuiListItemButton-root": { borderRadius: "0.65rem", width: "100%" },
                        "& .MuiListItem-root, & .MuiListItemButton-root, .MuiList-root.nav-transparent-alt .MuiListItem-root, .MuiList-root.nav-transparent-alt .MuiListItemButton-root": { width: "100%" },
                        "& .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root": { borderRadius: "0.65rem", width: "100%" },
                      }, { p: 0, m: 0, flexDirection: 'column' }, {
                        "& .MuiListItem-root.MuiListItem-button.Mui-selected, & .MuiListItem-root.MuiListItem-button:hover, & .MuiListItemButton-root.Mui-selected, & .MuiListItemButton-root:hover": {
                          color: "#4f5062",
                          background: "rgba(79, 80, 98, 0.05)",
                          "&::before": { background: "#4f5062" },
                        },
                      }]}>
                        <ListItemButton
                          onClick={() =>
                            handleOpenEditImage(selectedEditImage)
                          }
                          sx={{ whiteSpace: 'nowrap' }}
                        >
                          <EditIcon sx={strategyMarginRight10Sx} />
                          Edit Image
                        </ListItemButton>
                        <ListItemButton
                          onClick={toggleOpenDeleteImage(
                            selectedEditImage._id,
                          )}
                          sx={{ whiteSpace: 'nowrap' }}
                        >
                          <DeleteTwoTone sx={strategyMarginRight10Sx} />
                          Delete Image
                        </ListItemButton>
                      </List>
                    </Box>
                  </Menu>
                </Grid>
              </Grid>
              {/* <Grid size={12} sx={strategyMarginBottom25Sx}>
              <div>
                <Box {...getRootProps()} sx={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  outline: "none !important",
                  "& *": { outline: "none !important" },
                }}>
                  <input {...getInputProps()} />
                    <div>
                      <Box sx={strategyCenterTextSx}>
                        <Button variant='contained' margin='dense' sx={{ backgroundColor: '#368CFF', color: 'white' }}>Upload Additional Images</Button>
                      </div>
                  </div>
                </Box>
              </div>
            </Grid> */}
              <Grid size={{ sm: 12 }}>
                <Grid container direction="row" spacing={1}>
                  <Grid size={12}>
                    <Typography color="primary" variant="h6">
                      Property Details
                    </Typography>
                  </Grid>
                  {map(compFields, (field) => (
                    <Fragment key={field.name || field.label}>
                      {renderInput(field)}
                    </Fragment>
                  ))}
                  {/* <Grid size={12} sx={strategyMarginTop10OnlySx}>
                  <Typography color="primary" variant="h6">Financial Details</Typography>
                </Grid>
                {map(compFinancialFields, field => (
                  renderInput(field)
                ))} */}
                  {/* <Grid size={12} sx={strategyMarginTop5Sx}>
                  <Grid container>
                    <Grid size={12} sx={strategyMarginBottomNeg30Sx}>Adjust Comp</Grid>
                    <Grid size={12}>
                      <Slider
                        color="#008bff"
                        value={compPropertyInput.priceAdjustment}
                        onChange={(event, value) => {
                          onChangeSlider(
                            event,
                            value,
                            'priceAdjustment',
                          )
                        }}
                        onChangeCommitted={(event, value) => {
                          onChangeSlider(
                            event,
                            value,
                            'priceAdjustment',
                          )
                        }}
                        marks={true}
                        track={false}
                        valueLabelDisplay="auto"
                        reverse
                        min={-15}
                        max={15}
                        step={2.5}
                        valueLabelFormat={x => `${x}%`} sx={{
                          width: '95%',
                          marginLeft: '18px'}}/>
                    </Grid>
                  </Grid>
                </Grid> */}
                </Grid>
              </Grid>
            </Grid>
          </BlockUi>
        </DialogContent>
        <DialogActions>
          {edit && (
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={handleClickActionsMenu}
            >
              Actions
              <KeyboardArrowDownTwoTone />
            </Button>
          )}
          <Typography sx={strategyFlexGrowSx} />
          <Button
            size="small"
            variant="text"
            onClick={handleCloseAddComp}
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={submitComp()}
          >
            Save
          </Button>
        </DialogActions>
        <Menu
          anchorEl={anchorElActionsMenu}
          keepMounted
          open={Boolean(anchorElActionsMenu)}
          onClose={handleCloseActionsMenu}
          slotProps={{ list: { sx: { p: 0 } } }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Box sx={{ minWidth: "10rem" }}>
            <List
              component="div"
              disablePadding
              sx={{
                "& .MuiListItem-root.MuiListItem-button": { borderRadius: 0 },
                "& .MuiListItem-root.MuiListItem-button.Mui-selected, & .MuiListItem-root.MuiListItem-button:hover, & .MuiListItemButton-root.Mui-selected, & .MuiListItemButton-root:hover": {
                  color: "#368cff",
                  background: "rgba(54, 140, 255, 0.05)",
                  "&::before": { background: "#368cff" },
                },
              }}
            >
              {/* <ListItem key="changePotential" button onClick={submitComp(true)}>
              <Grid container spacing={2} sx={strategyPad5Sx}>
                <Grid size={3}><CompareOutlined sx={{ fontSize: 23 }}/></Grid>
                <Grid size={9}><span>Set as {potential ? 'Comp' : 'Potential'}</span></Grid>
              </Grid>
            </ListItem> */}
              <ListItemButton
                key="delete"
                onClick={toggleDeleteComp}
                sx={{ width: '100%' }}
              >
                <Box
                  sx={[
                    strategyPad5Sx,
                    {
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      width: '100%',
                    },
                  ]}
                >
                  <Box
                    sx={{
                      width: 28,
                      flexShrink: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <FontAwesomeIcon icon={['far', 'trash-can']} />
                  </Box>
                  <Box component="span" sx={{ whiteSpace: 'nowrap' }}>
                    Delete
                  </Box>
                </Box>
              </ListItemButton>
            </List>
          </Box>
        </Menu>
      </Dialog>
      <Dialog
        open={openDeleteComp}
        onClose={toggleDeleteComp}
      >
        <Box sx={{ textAlign: 'center', p: '3rem' }}>
          <Box sx={[{ borderRadius: '50%', m: 0 }, {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            mr: "0.25rem",
            position: "relative",
            fontSize: "1.2rem",
            transition: "all 0.2s ease-in-out",
            "&:last-child": { mr: 0, marginRight: 0 },
            "& .badge": { position: "absolute", right: 0, bottom: 0 },
            "& svg, & .svg-inline--fa": { display: "block" },
            marginRight: "0.25rem",
          }]}>
            <Box sx={[{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              border: 0,
              backgroundColor: "rgb(100%, 95.9215686275%, 96.418938307%) !important",
              height: "130px !important",
              width: "130px !important",
              lineHeight: "130px !important",
              p: 0,
              borderRadius: "50%",
              color: "#f83245",
              m: 0,
            }, {
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              mr: "0.25rem",
              position: "relative",
              fontSize: "1.2rem",
              transition: "all 0.2s ease-in-out",
              "&:last-child": { mr: 0, marginRight: 0 },
              "& .badge": { position: "absolute", right: 0, bottom: 0 },
              "& svg, & .svg-inline--fa": { display: "block" },
              marginRight: "0.25rem",
            }]}>
              <FontAwesomeIcon icon={['fas', 'xmark']} sx={[{ fontSize: "2.5rem", fontWeight: "300", lineHeight: "1.2" }, strategyFlexSelfCenterSx]} />
            </Box>
          </Box>
          <Box component="h4" sx={{ fontWeight: 700, mt: '1.5rem' }}>
            Are you sure you want to delete this?
          </Box>
          <Box component="p" sx={[{ mb: 0, color: '#a6a6b9' }, { fontSize: "1.15rem !important" }]}>
            All data will be deleted. This action cannot be undone.
          </Box>
          <Box sx={{ pt: '1.5rem' }}>
            <Button
              variant="text"
              onClick={toggleDeleteComp}
              //
            >
              <Box component="span" sx={{
                display: "inline-block",
                "&:not(:first-of-type)": { ml: "0.5rem", marginLeft: "0.5rem" },
                "& + .btn-wrapper--icon": { ml: "0.5rem", marginLeft: "0.5rem" },
              }}>Cancel</Box>
            </Button>
            <Button
              variant="contained"
             
              onClick={onDelete}
              sx={strategyDangerChipSx}
            >
              <Box component="span" sx={{
                display: "inline-block",
                "&:not(:first-of-type)": { ml: "0.5rem", marginLeft: "0.5rem" },
                "& + .btn-wrapper--icon": { ml: "0.5rem", marginLeft: "0.5rem" },
              }}>Delete</Box>
            </Button>
          </Box>
        </Box>
      </Dialog>
      <ImageCropper
        open={openEditImage}
        imageSrc={selectedEditImage.url || selectedEditImage}
        saveImage={saveCroppedImage}
        replaceOption={true}
        handleClose={handleCloseEditImage}
      />
      <Dialog
        open={openDeleteImage}
        onClose={toggleOpenDeleteImage()}
      >
        <DialogTitle sx={strategyPadBottom0Sx}>
          Delete Image
        </DialogTitle>

        <form
          onSubmit={(event) => onSubmitDelete(event)}
        >
          <DialogContent>
            Are you sure you want to delete this image? This action
            can't be undone.
          </DialogContent>
          <DialogActions>
            <Button onClick={toggleOpenDeleteImage()}>CANCEL</Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loader}
            >
              DELETE
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {menu && (
        <Menu
          anchorEl={anchorElDefinition}
          open={Boolean(anchorElDefinition)}
          onClose={() => handleDefinition('', null, null, null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          slotProps={{
            list: { sx: { p: 0 }, dense: true },
          }} sx={strategyWidth400Sx}>
          <Box sx={{ minWidth: "22rem" }}>
            <MenuItem key="menuTitle">
              <Typography variant="h6">{startCase(menu)}</Typography>
            </MenuItem>
            <MenuItem key="menuDescription">
              <Typography
                variant="subtitle2"
                color="textSecondary" sx={strategyWhiteSpaceNormalSx}>
                We found multiple values for this field. Please choose
                the correct option.
              </Typography>
            </MenuItem>
            {map(propertyData[menu], (value) => (
              <MenuItem
                key={menu + ': ' + value}
                onClick={() => {
                  if (menu === 'soldDate') onChangeDateMenu(value)
                  else
                    handleCompChange({
                      target: { name: menuName, value },
                    })
                  handleDefinition('', null, null)
                }}
              >
                <Typography sx={strategyFlexGrowSx} />
                <ListItemText>
                  {menuFormat ? menuFormat.format(value) : value}
                </ListItemText>
              </MenuItem>
            ))}
          </Box>
        </Menu>
      )}
    </>
  )
}

export default CenterPageComps
